import { Component, OnInit, inject } from "@angular/core";
import { DataAccessService } from "../core/services/data-access.service";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { AppComponent } from "../app.component";
import { MatCard, MatCardContent, MatCardActions } from "@angular/material/card";
import { FormsModule } from "@angular/forms";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";

@Component({
    selector: "app-settings",
    templateUrl: "./settings.component.html",
    styleUrls: ["./settings.component.scss"],
    providers: [DataAccessService],
    imports: [MatCard, MatCardContent, FormsModule, MatFormField, MatLabel, MatInput, MatCardActions, MatButton]
})
export class SettingsComponent implements OnInit {
  private router = inject(Router);
  private dataAccess = inject(DataAccessService);
  private app = inject(AppComponent);

  passwordOld: string;
  passwordNew: string;
  passwordRepeat: string;
  errorMsg: string;
  forceChange: boolean;

  ngOnInit() {
    this.forceChange = (
      this.dataAccess.getLoginData() as any
    ).password_change_required;
  }

  changePassword() {
    if (this.passwordNew !== this.passwordRepeat) {
      this.errorMsg = "Passwords don't match!";
      return;
    } else {
      this.errorMsg = "";
    }

    this.dataAccess
      .getJSONPost(
        "change_password",
        [],
        [
          { k: "p_passwd", v: this.passwordNew },
          { k: "p_passwd_old", v: this.passwordOld },
          { k: "p_require_old_password", v: !this.forceChange },
        ]
      )
      .then((data) => {
        if (data.res != 0) {
          Swal.fire("Error!", data.msg, "error");
        } else {
          Swal.fire({
            title: "Password changed!",
            html: "Redirecting...",
            icon: "success",
            timer: 1500,
            timerProgressBar: true,
            willClose: () => {
              const data = this.dataAccess.getLoginData();
              (data as any).password_change_required = false;
              this.dataAccess.setLoginData(data);
              this.router.navigate(["/home"]);
            },
          });
        }
      });
  }
}
